<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="snRule.pkid > 0 ? '编辑' : '新建'"
        width="900px"
        class="barCodeRulesEdit"
        top="0"
        @close="$reset('form')">
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="snRule"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="规则编号" prop="snRuleNo">
              <el-input v-model="snRule.snRuleNo" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规则类型" prop="snType">
              <el-select v-model="snRule.snType" clearable placeholder="请选择规则类型">
                <el-option v-for="item in snTypes" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规则样式" prop="snRuleExpression">
              <el-input v-model.trim="snRule.snRuleExpression" placeholder="请输入规则样式" @input="snRuleExpressionChange"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字符总数">
              <el-input v-model="snRule.snLength" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规则状态" prop="status">
              <el-select v-model="snRule.status" clearable placeholder="请选择规则状态">
                <el-option v-for="item in snStatus" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="规则描述" prop="snRuleExpressionDesc">
              <el-input v-model="snRule.snRuleExpressionDesc" autosize type="textarea" placeholder="请输入规则描述"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注">
              <el-input v-model="snRule.snRuleDesc" autosize type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">元码信息</div>
        <el-button type="primary" style="margin-bottom: 10px" @click="$refs.editDetailsPage.open(0, -1)"> 新建 </el-button>
        <el-table border :data="tableData">
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
              prop="metaDataDesc"
              align="left"
              width="160"
              show-overflow-tooltip
              label="元码编号"/>
          <el-table-column prop="metaDataLable" align="center" label="源码标签" show-overflow-tooltip/>
          <el-table-column prop="metaDataName" align="left" label="源码名称" show-overflow-tooltip/>
          <el-table-column prop="lableLength" align="center" label="标签个数" show-overflow-tooltip/>
          <el-table-column prop="dataSource" align="center" label="数据源" show-overflow-tooltip/>
          <el-table-column prop="suffixChar" align="center" label="后缀" show-overflow-tooltip/>
          <el-table-column prop="isVerify" align="center" label="是否验证">
            <template slot-scope="scope">
              <el-tag>
                {{scope.row.isVerify ? "是" : "否"}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120px">
            <template slot-scope="scope">
              <el-button type="primary" @click="$refs.editDetailsPage.open(scope.row, scope.$index)">编辑</el-button>
              <el-button type="danger" @click="oneDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
    <bar-code-rules-details-edit ref="editDetailsPage" @save-success="getList"/>
  </div>
</template>

<script>
  import BarCodeRulesDetailsEdit from "@/views/information/BarCodeRules/BarCodeRulesDetailsEdit";
  export default {
    name: "BarCodeRulesEdit",
    components: { BarCodeRulesDetailsEdit },
    props: {
      snTypes: {
        type: Array,
        required: true,
      },
      snStatus: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        snRule: {
          pkid: "",
          snRuleNo: "",
          snRuleExpression: "",
          snRuleExpressionDesc: "",
          snType: "",
          snLength: "",
          snRuleDesc: "",
          status: "",
          snRuleDetails: [],
        },
        tableData: [],
        ruleValidate: {
          snRuleNo: { required: true, message: "规则编号不能为空" },
          snType: { required: true, message: "请选择规则类型", trigger: "change" },
          snRuleExpression: { required: true, message: "请输入规则样式", trigger: "blur" },
          snRuleExpressionDesc: { required: true, message: "请输入规则描述", trigger: "blur" },
          status: { required: true, message: "请选择状态", trigger: "change" },
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.snRule.pkid = row.pkid;
          this.getData();
        } else {
          this.getRuleNo();
        }
      },

      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `snRule/${this.snRule.pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.snRule = resp.data;
              this.tableData = this.snRule.snRuleDetails;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 获取规则编号
      getRuleNo() {
        this.$http.get("basic", "snRule/genNo").then((resp) => {
          if (resp.success) {
            this.snRule.snRuleNo = resp.data;
          }
        });
      },

      snRuleExpressionChange(value) {
        if (value) {
          // 去除字符串中所有的空格
          let newStr = this.snRule.snRuleExpression.replace(/\s\*/g, "");
          this.snRule.snLength = newStr.length;
        }
      },

      // 详情表信息
      getList(row, index) {
        if (index >= 0) {
          this.tableData[index].pkid = row.pkid;
          this.tableData[index].rowIndex = index + 1;
          this.tableData[index].metaDataNo = row.metaDataNo;
          this.tableData[index].metaDataLable = row.metaDataLable;
          this.tableData[index].metaDataName = row.metaDataName;
          this.tableData[index].lableLength = row.lableLength;
          this.tableData[index].dataSource = row.dataSource;
          this.tableData[index].suffixChar = row.suffixChar;
          this.tableData[index].isVerify = row.isVerify;
          this.tableData[index].metaDataDesc = row.metaDataDesc;
        } else {
          this.tableData.push({
            pkid: 0,
            rowIndex: this.tableData.length + 1,
            metaDataNo: row.metaDataNo,
            metaDataLable: row.metaDataLable,
            metaDataName: row.metaDataName,
            lableLength: row.lableLength,
            dataSource: row.dataSource,
            suffixChar: row.suffixChar,
            isVerify: row.isVerify,
            metaDataDesc: row.metaDataDesc,
          });
        }
      },

      //详情表删除
      oneDelete(index) {
        this.tableData.splice(index, 1);
        //使tableData重新排序
        this.tableData.forEach((item, index) => {
          item.rowIndex = index + 1;
        });
      },

      // 提交
      handleSubmit() {
        this.snRule.snRuleDetails = this.tableData;
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.tableData.length === 0) {
              this.$confirm("请添加元码信息", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "snRule", this.snRule)
              .then((resp) => {
                if (resp.success) {
                  if (this.snRule.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                }
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
.barCodeRulesEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.barCodeRulesEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.barCodeRulesEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.barCodeRulesEdit .el-divider--horizontal {
  margin: 10px 0;
}

.barCodeRulesEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>
